export const colors = {
	white: '#FFF',
	black: '#000',
	cyan10: '#CEF',
	cyan60: '#08C',
	gray04: '#F5F5F5',
	gray05: '#F2F2F2',
	gray10: '#E6E6E6',
	gray20: '#ADEABC',
	gray40: '#999',
	gray50: '#808080',
	gray70: '#4D4D4D',
	indigo05: '#EDEDF7',
	indigo10: '#DBDBF0',
	indigo20: '#B8B8E0',
	indigo30: '#9494D1',
	indigo50: '#4D4DB3',
	indigo60: '#3D3D8F',
	indigo70: '#2E2E6B',
	indigoTransparent_90: 'rgba(31, 31, 71, 0.9)',
	pink10: '#F7D4DA',
	pink20: '#F0A8B4',
	pink50: '#D92644',
	pink60: '#AD1F36',
	green10: '#D5F5DE',
	green20: '#ADEABC',
	green50: '#33CC59',
	green60: '#29A347',
	green70: '#1F7A36',
	pink: '#B54A71',
	purple50: '#B44BA0',
	blue50: '#2E9DD1',
	darkblue50: '#587CA7',
	yellow50: '#FFD600',
	turquoise50: '#24DBA4',
	violet50: '#663AC5',
	violet60: '#48428A',
	orange70: '#995900',
	orange50: '#FF9500',
	orange20: '#FFD599',
	orange10: '#FFEACC',
	darkPurple: '#781A8F',
	lightPurple: '#A70082',
	darkGreen: '#108F61',
	indigoLavender: '#9959EB',
	vividViolet: '#8E0BAE',
	pacificBlue: '#2694C4',
	brightTurquoise: '#0FDBDB',
	limeGreen: '#79E840',
	outrageousOrange: '#FF6B34',
	vividCerise: '#F23370',
	red50: '#D22D2D',
	red60: '#A82424',
	jungleGreen: '#18ACA3',
	serviceLevelGood: '#54BB1E',
	serviceLevelVariable: '#ffd700',
	serviceLevelNoService: '#C41F2B',
};

export const userBgColors = [
	colors.green50,
	colors.pink50,
	colors.purple50,
	colors.blue50,
	colors.darkblue50,
	colors.yellow50,
	colors.turquoise50,
	colors.violet50,
];

export const backgroundColorsLineChart = [
	'#9494D1',
	'#6CF',
	'#85E09C',
	'#E87D8F',
	'#C285E0',
	'#FFBF66',
	'#68FDE2',
	'#E67FD6',
	'#FF8566',
	'#948BF3',
	'#E6E27F',
	'#C3F570',
	'#A5AECF',
	'#C290D1',
	'#EAB48A',
	'#F5F080',
];

export const borderColors = [
	'#2E2E6B',
	'#0AF',
	'#33CC59',
	'#D92644',
	'#93C',
	'#FF9500',
	'#04ECC2',
	'#CC28B2',
	'#FF5023',
	'#5144EC',
	'#CFC929',
	'#6DA90B',
	'#4C5DA0',
	'#8622A4',
	'#D56915',
	'#ECE200',
];

export const backgroundColorsBarChart = [
	'rgba(46, 46, 107, 0.7)',
	'rgba(0, 170, 255, 0.7)',
	'rgba(51, 204, 89, 0.7)',
	'rgba(217, 38, 68, 0.7)',
	'rgba(153, 51, 204, 0.7)',
	'rgba(255, 149, 0, 0.7)',
	'rgba(4, 236, 194, 0.7)',
	'rgba(204, 40, 178, 0.7)',
	'rgba(255, 80, 35, 0.7)',
	'rgba(81, 68, 236, 0.7)',
	'rgba(207, 201, 41, 0.7)',
	'rgba(109, 169, 11, 0.7)',
	'rgba(76, 93, 160, 0.70)',
	'rgba(134, 34, 164, 0.70)',
	'rgba(213, 105, 21, 0.70)',
	'rgba(236, 226, 0, 0.70)',
];

export const predefinedColors = {
	AMBER: colors.yellow50,
	RED: colors.pink50,
	GREEN: colors.green50,
	DARK_PURPLE: colors.darkPurple,
	LIGHT_PURPLE: colors.lightPurple,
	DARK_GREEN: colors.darkGreen,
	ORANGE: colors.outrageousOrange,
};

export default colors;
